
import { computed, defineComponent, PropType } from "vue";
import { Message } from "@/types/conversation";
import { MessageDataConversationTransferred } from "@/types/inboundWebhookPayload";
import { formatPhoneNumber } from "@/util/formatting";
import { useConversation } from "@/composables/conversation";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "MessengerMessageEvent",
  components: {},
  props: {
    message: {
      type: Object as PropType<Message>,
      required: true,
    },
  },
  setup(props) {
    const { isTransferredAndWithinNewMessageThreshold } = useConversation();
    const { t } = useI18n();

    const humanChannel: Record<
      MessageDataConversationTransferred["targetChannel"],
      string
    > = {
      email: t("messengerMessageEvent.emailChannel"),
      sms: "SMS",
      whatsapp: "WhatsApp",
    };

    const resolvedMessage = computed(() => {
      switch (props.message.data.eventType) {
        case "conversation_ended": {
          return t("messengerMessageEvent.conversationEnded");
        }

        case "conversation_transferred": {
          const hasChannel =
            !!props.message.data.conversationTransferred?.targetChannel;
          const hasAddress =
            !!props.message.data.conversationTransferred?.targetAddress;
          let formattedAddress = "";

          if (hasChannel && hasAddress) {
            switch (props.message.data.conversationTransferred!.targetChannel) {
              case "sms":
              case "whatsapp": {
                formattedAddress = formatPhoneNumber(
                  props.message.data.conversationTransferred!.targetAddress!
                );
                break;
              }

              default: {
                formattedAddress =
                  props.message.data.conversationTransferred!.targetAddress!;
              }
            }
          }

          let text = hasChannel
            ? t("messengerMessageEvent.wellGetBackToYouWithChannel", {
                channel: `${
                  humanChannel[
                    props.message.data.conversationTransferred!.targetChannel
                  ]
                }${hasAddress ? ` (${formattedAddress})` : ""}`,
              })
            : t("messengerMessageEvent.wellGetBackToYouWithoutChannel");

          if (isTransferredAndWithinNewMessageThreshold.value) {
            text += ` ${t("messengerMessageEvent.additionalInfoQuestion")}`;
          }

          return text;
        }

        default:
          throw new Error(
            `Unsupported message event type: ${props.message.data.eventType}`
          );
      }
    });

    return {
      resolvedMessage,
    };
  },
});
